module.exports = __webpack_public_path__ + "img/logo.1ac0c16c.png";